import { Button, Form, Input } from 'antd';
import React, { useState } from 'react';
import YogaIDCard from './Yogacard';
import { useNavigate } from 'react-router-dom';
import Axios from '../../../services/AxiosInterceptor';
const AddStaffs = () => {
  // Define state for each input field
  const [staffDetails, setStaffDetails] = useState({
    name: '',
    email: '',
    phone: '',
    age: '',
    emergencyContact: '',
    address: '',
    department: '',
    position: '',
    startDate: '',
  });

  // State for error messages (for form validation)
  const [errors, setErrors] = useState({});
const navigate=useNavigate()
  // Handle form input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setStaffDetails({
      ...staffDetails,
      [name]: value,
    });
  };

  // Basic form validation
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    // Validate Name (cannot be empty)
    if (!staffDetails.name) {
      formErrors.name = 'Name is required';
      isValid = false;
    }

    // Validate Email (check for proper email format)
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    if (!staffDetails.email || !emailRegex.test(staffDetails.email)) {
      formErrors.email = 'Valid email is required';
      isValid = false;
    }

    // Validate Phone (should be 10 digits)
    const phoneRegex = /^[0-9]{10}$/;
    if (!staffDetails.phone || !phoneRegex.test(staffDetails.phone)) {
      formErrors.phone = 'Valid phone number is required';
      isValid = false;
    }

    // Validate Age (should be a number between 18 and 100)
    if (!staffDetails.age || staffDetails.age < 18 || staffDetails.age > 100) {
      formErrors.age = 'Valid age (18-100) is required';
      isValid = false;
    }

    // Validate Emergency Contact (should be a 10-digit number)
    if (!staffDetails.emergencyContact || !phoneRegex.test(staffDetails.emergencyContact)) {
      formErrors.emergencyContact = 'Valid emergency contact number is required';
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  // Handle form submission
  const handleSubmit = async(e) => {
    console.log(e)
    e.preventDefault();
    if (validateForm()) {
        const formData = {
            name: staffDetails.name,
            email: staffDetails.email,
            phone: staffDetails.phone,
            age: staffDetails.age,
            emergencyContact: staffDetails.emergencyContact,
            address: staffDetails.address,
            department: staffDetails.department,
            position: staffDetails.position,
            startDate: staffDetails.startDate
          };
          try {
  const response = await Axios.post(
    'api/add-staff',
    formData, // <-- data goes here
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  const result = response.data; // Axios returns data here

  if (result) {
    navigate("/stafflist");
  }

  console.log(result);

} catch (error) {
            console.error('Error adding staff:', error);
          }
        
      // Reset form
      setStaffDetails({
        name: '',
        email: '',
        phone: '',
        age: '',
        emergencyContact: '',
        address: '',
        department: '',
        position: '',
        startDate: '',
      });
      alert('Staff Added Successfully!');
    }
  };
   const photo="data:image/jpeg;base64,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"

  return (
    <div>
      <h3>Add New Staff</h3>
      <YogaIDCard name={staffDetails.name} age={staffDetails.age} photo={photo}/>
      <Form style={{display:"flex",flexWrap:"wrap",gap:"20px",borderRadius: "10px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        padding: "20px",
        background: "#f5f5f5",marginTop:"40px"}}>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <Input
            type="text"
            id="name"
            name="name"
            value={staffDetails.name}
            onChange={handleChange}
            placeholder="Enter Name"
          />
          {errors.name && <span style={{color:"red"}}>{errors.name}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <Input
            type="email"
            id="email"
            name="email"
            value={staffDetails.email}
            onChange={handleChange}
            placeholder="Enter Email"
          />
          {errors.email && <span style={{color:"red"}}>{errors.email}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <Input
            type="text"
            id="phone"
            name="phone"
            value={staffDetails.phone}
            onChange={handleChange}
            placeholder="Enter Phone Number"
          />
          {errors.phone && <span style={{color:"red"}}>{errors.phone}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="age">Age</label>
          <Input
            type="number"
            id="age"
            name="age"
            value={staffDetails.age}
            onChange={handleChange}
            placeholder="Enter Age"
          />
          {errors.age && <span style={{color:"red"}}>{errors.age}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="emergencyContact">Emergency Contact</label>
          <Input
            type="text"
            id="emergencyContact"
            name="emergencyContact"
            value={staffDetails.emergencyContact}
            onChange={handleChange}
            placeholder="Enter Emergency Contact Number"
          />
          {errors.emergencyContact && <span style={{color:"red"}}>{errors.emergencyContact}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="address">Address</label>
          <Input
            type="text"
            id="address"
            name="address"
            value={staffDetails.address}
            onChange={handleChange}
            placeholder="Enter Address"
          />
        </div>

        <div className="form-group">
          <label htmlFor="department">Department</label>
          <Input
            type="text"
            id="department"
            name="department"
            value={staffDetails.department}
            onChange={handleChange}
            placeholder="Enter Department"
          />
        </div>

        <div className="form-group">
          <label htmlFor="position">Position</label>
          <Input
            type="text"
            id="position"
            name="position"
            value={staffDetails.position}
            onChange={handleChange}
            placeholder="Enter Position"
          />
        </div>

        <div className="form-group">
          <label htmlFor="startDate">Start Date</label>
          <Input
            type="date"
            id="startDate"
            name="startDate"
            value={staffDetails.startDate}
            onChange={handleChange}
          />
        </div>

      
      </Form>
      <div className="form-group">
          <Button onClick={(e)=>handleSubmit(e)}  style={{background:"orange",marginTop:"20px"}} type="submit">Add Staff</Button>
        </div>
    </div>

  );
};

export default AddStaffs;
